import ChartsService from '@/services/benchmarks/ChartsService.js';
import { getBenchmarkId } from '@/utils';

export async function fetchFollowersByChannel({ rootState }, { groupName, groupId }) {
  try {
    const channels = rootState.benchmarks.channels;

    const { data, total_followers } = await ChartsService.getFollowersByChannel({
      'group-id': groupId,
      'benchmark-id': getBenchmarkId(),
      'start-date': rootState.ui.dateRange.start,
      'end-date': rootState.ui.dateRange.end,
    });

    const formattedData = data
      .map(({ channel, percent, period_variation, y }) => ({
        y,
        percent,
        period_variation,
        name: channel,
        color: channels.find((c) => c.channel === channel).hex_color,
      }))
      .sort((a, b) => (a.name > b.name ? 1 : -1));

    return {
      data: formattedData,
      totalFollowers: total_followers,
      label: groupName,
      requestStatus: data.length > 0 ? 'success' : '',
    };
  } catch (e) {
    console.error(e);
    return {
      label: groupName,
      requestStatus: 'error',
    };
  }
}
